module.exports = __webpack_public_path__ + "public/img/upLoadData.907130fa.png";